/**
 * ログイン / 会員登録リンクに戻り先を付与する。
 * TPA・Prime Review 等のアプリモーダル内リンクにも対応。
 * Shop（Sign in with Shop）ログイン後の /account リダイレクトにも対応。
 */
(function () {
  const STORAGE_RETURN = 'cheerium_login_return';
  const STORAGE_PENDING = 'cheerium_login_redirect_pending';

  const LOGIN_PATHS = ['/account/login', '/customer_authentication/login', '/customer_identity/login'];
  const REGISTER_PATHS = ['/account/register'];
  const SHOP_LOGIN_SELECTORS = [
    '[name="sign-in-with-shop-provider"]',
    'shop-login-button',
    'shop-pay-login',
    'shop-login',
  ].join(', ');

  function getReturnPath() {
    return window.location.pathname + window.location.search;
  }

  function getReturnPathFromUrl(search) {
    const params = new URLSearchParams(search || window.location.search);
    return params.get('checkout_url') || params.get('return_to') || '';
  }

  function isValidReturnPath(path) {
    if (!path || typeof path !== 'string') return false;
    if (!path.startsWith('/') || path.startsWith('//')) return false;
    if (path.startsWith('/account/login')) return false;
    if (path.startsWith('/account/register')) return false;
    return true;
  }

  function markLoginRedirectPending(returnPath) {
    if (!isValidReturnPath(returnPath)) return;
    sessionStorage.setItem(STORAGE_RETURN, returnPath);
    sessionStorage.setItem(STORAGE_PENDING, '1');
  }

  function clearLoginRedirectPending() {
    sessionStorage.removeItem(STORAGE_RETURN);
    sessionStorage.removeItem(STORAGE_PENDING);
  }

  function isAuthPage(path) {
    const currentPath = path || window.location.pathname;

    return (
      LOGIN_PATHS.some((p) => currentPath === p || currentPath.endsWith(p)) ||
      REGISTER_PATHS.some((p) => currentPath === p || currentPath.endsWith(p)) ||
      currentPath === '/account/recover' ||
      currentPath.startsWith('/account/activate') ||
      currentPath.startsWith('/account/reset')
    );
  }

  function isPostLoginAccountLanding() {
    if (isAuthPage()) return false;

    const path = window.location.pathname;
    return path === '/account' || path.startsWith('/account/');
  }

  function handlePostLoginRedirect() {
    if (isAuthPage()) return;
    if (sessionStorage.getItem(STORAGE_PENDING) !== '1') return;

    const returnPath = sessionStorage.getItem(STORAGE_RETURN);
    if (!isValidReturnPath(returnPath)) {
      clearLoginRedirectPending();
      return;
    }

    const currentPath = getReturnPath();

    if (currentPath === returnPath) {
      clearLoginRedirectPending();
      return;
    }

    if (isPostLoginAccountLanding()) {
      clearLoginRedirectPending();
      window.location.replace(returnPath);
    }
  }

  function initAuthPageReturnPath() {
    if (!isAuthPage()) return;

    const returnPath = getReturnPathFromUrl();
    if (isValidReturnPath(returnPath)) {
      markLoginRedirectPending(returnPath);
    }
  }

  function isAuthLink(href) {
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return false;

    try {
      const url = new URL(href, window.location.origin);
      const path = url.pathname;

      return (
        LOGIN_PATHS.some((p) => path === p || path.endsWith(p)) ||
        REGISTER_PATHS.some((p) => path === p || path.endsWith(p))
      );
    } catch {
      return false;
    }
  }

  function hasReturnParam(url) {
    return url.searchParams.has('checkout_url') || url.searchParams.has('return_to');
  }

  function appendReturnToHref(href) {
    if (!isAuthLink(href)) return href;

    try {
      const url = new URL(href, window.location.origin);
      if (hasReturnParam(url)) return href;

      const returnPath = getReturnPath();
      const path = url.pathname;

      if (path.includes('/customer_authentication/login') || path.includes('/customer_identity/login')) {
        url.searchParams.set('return_to', returnPath);
      } else {
        url.searchParams.set('checkout_url', returnPath);
      }

      return url.pathname + url.search + url.hash;
    } catch {
      return href;
    }
  }

  function extractReturnPathFromHref(href) {
    if (!href) return '';

    try {
      const url = new URL(href, window.location.origin);
      return url.searchParams.get('checkout_url') || url.searchParams.get('return_to') || '';
    } catch {
      return '';
    }
  }

  function patchLink(link) {
    const href = link.getAttribute('href');
    if (!href) return;

    const newHref = appendReturnToHref(href);
    if (newHref !== href) {
      link.setAttribute('href', newHref);
    }
  }

  function patchAuthLinks(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(patchLink);
  }

  function saveReturnPathForShopLogin(sourcePath) {
    const queryReturn = getReturnPathFromUrl();
    const hrefReturn = sourcePath || queryReturn || getReturnPath();

    if (isValidReturnPath(hrefReturn)) {
      markLoginRedirectPending(hrefReturn);
      return;
    }

    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin === window.location.origin) {
          const referrerPath = referrerUrl.pathname + referrerUrl.search;
          const referrerQueryReturn = getReturnPathFromUrl(referrerUrl.search);

          if (isValidReturnPath(referrerQueryReturn)) {
            markLoginRedirectPending(referrerQueryReturn);
            return;
          }

          if (isValidReturnPath(referrerPath)) {
            markLoginRedirectPending(referrerPath);
          }
        }
      } catch {
        /* noop */
      }
    }
  }

  function bindShopLoginTriggers(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(SHOP_LOGIN_SELECTORS).forEach(function (el) {
      if (el.dataset.cheeriumShopLoginBound) return;
      el.dataset.cheeriumShopLoginBound = '1';

      el.addEventListener(
        'click',
        function () {
          saveReturnPathForShopLogin(getReturnPathFromUrl() || getReturnPath());
        },
        true
      );
    });
  }

  initAuthPageReturnPath();
  handlePostLoginRedirect();
  bindShopLoginTriggers(document.body);

  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest('a[href]');

      if (link) {
        patchLink(link);

        if (isAuthLink(link.getAttribute('href'))) {
          const href = link.getAttribute('href');
          const returnPath =
            extractReturnPathFromHref(href) || getReturnPath();

          markLoginRedirectPending(returnPath);
        }
      }

      if (event.target.closest(SHOP_LOGIN_SELECTORS)) {
        saveReturnPathForShopLogin(getReturnPathFromUrl() || getReturnPath());
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAuthPageReturnPath();
      handlePostLoginRedirect();
      patchAuthLinks(document.body);
      bindShopLoginTriggers(document.body);
    });
  } else {
    patchAuthLinks(document.body);
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      handlePostLoginRedirect();
    }
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches && node.matches('a[href]')) {
          patchLink(node);
        }

        patchAuthLinks(node);

        if (node.querySelectorAll) {
          bindShopLoginTriggers(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
